import React from 'react';

import PropTypes from 'prop-types';

import { componentMap } from './DecoratorOption.constants';

const DecoratorOption = ({ value }) => {
  const Component = componentMap[value];

  return Component ? <Component /> : null;
};

DecoratorOption.propTypes = {
  value: PropTypes.string.isRequired,
};

export default DecoratorOption;
